/* ===== Cenzio — urun sayfasi etkilesimleri ===== */
(function () {
  'use strict';

  var FRAME_COLORS = {
    black: '#1b1b1b', espresso: '#4a3527', natural: '#c9a06a',
    white: '#f2efe9', walnut: '#6b4a2f', oak: '#d8b98a', gold: '#c9a227', silver: '#c8c8c8'
  };

  /* Shop Pay taksit formu da action="/cart/add" kullanir ve DOM'da once gelir;
     bu yuzden once <product-form> icindeki gercek formu ararız. */
  function addForm() {
    return document.querySelector('product-form form')
        || document.querySelector('form[action*="/cart/add"]:not(.installment)');
  }
  function addButton(form) {
    if (!form) return null;
    return form.querySelector('[name="add"]')
        || form.querySelector('button[type="submit"]')
        || form.querySelector('.product-form__submit');
  }

  function legendText(field) {
    var l = field.querySelector('legend, .form__label');
    return l ? l.textContent.toLowerCase() : '';
  }

  function parseInches(txt) {
    var m = String(txt).match(/(\d+(?:\.\d+)?)\s*["″”]?\s*[x×]\s*(\d+(?:\.\d+)?)/i);
    if (!m) return null;
    return { w: parseFloat(m[1]), h: parseFloat(m[2]) };
  }
  function toCm(i) { return Math.round(i * 2.54); }
  function num(n) { return String(Math.round(n * 100) / 100); }

  /* --- Beden basina fiyat ---
     Harita cz-pdp-buy.liquid icinde Liquid ile basiliyor; burada yalnizca
     okunuyor. Bicimlendirme orada yapildi cunku sayfa hangi para biriminde
     basildiysa money filtresi onu veriyor. */
  var PRICES = null;
  function normSize(v) {
    return String(v).replace(/[”″]/g, '"').replace(/\s+/g, ' ').trim().toLowerCase();
  }
  function sizePrice(val) {
    if (PRICES === null) {
      PRICES = {};
      var el = document.querySelector('[data-cz-sizeprice]');
      if (el) { try { PRICES = JSON.parse(el.textContent) || {}; } catch (e) { PRICES = {}; } }
    }
    if (PRICES[val]) return PRICES[val];
    /* Etikette bosluk/tirnak yazimi option degerinden farkli olabiliyor */
    var k = normSize(val);
    for (var key in PRICES) {
      if (PRICES[key] && normSize(key) === k) return PRICES[key];
    }
    return '';
  }

  function firstTextNode(el) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) return n;
    }
    return null;
  }

  /* --- Beden pillerine cm, renk pillerine nokta --- */
  function decorateOptions() {
    document.querySelectorAll('.product-form__input--pill').forEach(function (field) {
      var legend = legendText(field);
      var isSize = /size|beden|boyut/.test(legend);
      var isColor = /colou?r|frame|renk/.test(legend);
      if (!isSize && !isColor) return;

      /* Izgara duzeni bu iki alan icin */
      if (isSize) field.classList.add('cz-opt--size');
      if (isColor) field.classList.add('cz-opt--color');

      field.querySelectorAll('label').forEach(function (label) {
        if (label.hasAttribute('data-cz-done')) return;
        var tn = firstTextNode(label);
        if (!tn) return;
        var txt = tn.textContent.trim();

        if (isSize) {
          var d = parseInches(txt);
          if (d) {
            /* Ham deger olcu rehberi eslesmesi icin saklanir */
            if (!label.hasAttribute('data-cz-raw')) label.setAttribute('data-cz-raw', txt);
            /* Printify'dan gelen karisik yazim tek bicime indirilir:
               9" x 12" (Vertical) -> 9″ × 12″ */
            tn.textContent = num(d.w) + '″ × ' + num(d.h) + '″';

            var s = document.createElement('span');
            s.className = 'cz-cm';
            s.textContent = toCm(d.w) + ' × ' + toCm(d.h) + ' cm';
            /* Fiyat ayni satira giriyor; kutu yuksekligi degismesin diye
               ikinci bir satir acmiyoruz. */
            var pr = sizePrice(txt);
            if (pr) {
              var sep = document.createElement('span');
              sep.className = 'cz-prsep';
              sep.textContent = '·';
              var b = document.createElement('span');
              b.className = 'cz-pr';
              b.textContent = pr;
              s.appendChild(sep);
              s.appendChild(b);
            }
            label.appendChild(s);

            /* Telefonda, kutunun solunda bedenin oranini gosteren minik bir
               cerceve: 32 inc = 18px. Ayni hizada duran kutularda hangi
               bedenin ne kadar buyudugu bir bakista okunur. (cz-mobile-2.css) */
            var mini = document.createElement('span');
            mini.className = 'cz-szmini';
            mini.setAttribute('aria-hidden', 'true');
            var box = document.createElement('i');
            var k = 18 / 32;
            box.style.width = Math.max(4, Math.round(d.w * k)) + 'px';
            box.style.height = Math.max(4, Math.round(d.h * k)) + 'px';
            mini.appendChild(box);
            label.insertBefore(mini, label.firstChild);
          }
        } else if (isColor) {
          var key = txt.toLowerCase().replace(/[^a-z]/g, '');
          var hex = FRAME_COLORS[key];
          if (hex) {
            var dot = document.createElement('span');
            dot.className = 'cz-dot';
            dot.style.background = hex;
            label.insertBefore(dot, label.firstChild);
          }
        }
        label.setAttribute('data-cz-done', '');
      });
    });
  }

  /* --- Teslimat tahmini --- */
  function addBusinessDays(date, n) {
    var d = new Date(date.getTime()), added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }
  function fmt(d) {
    try { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
    catch (e) { return (d.getMonth() + 1) + '/' + d.getDate(); }
  }
  function deliveryEstimate() {
    var el = document.querySelector('[data-cz-deliv]');
    if (!el) return;
    var lo = parseInt(el.getAttribute('data-min') || '3', 10);
    var hi = parseInt(el.getAttribute('data-max') || '7', 10);
    var now = new Date();
    el.textContent = fmt(addBusinessDays(now, lo)) + ' – ' + fmt(addBusinessDays(now, hi));
  }

  /* --- Galeri sayaci --- */
  var galleryInit = false;
  function galleryCounter() {
    if (galleryInit) return;
    var wrap = document.querySelector('.product__media-wrapper');
    if (!wrap) return;
    var list = wrap.querySelector('.product__media-list');
    if (!list) return;

    function slides() {
      return Array.prototype.slice.call(list.querySelectorAll('.product__media-item'))
        .filter(function (n) {
          return !n.hasAttribute('hidden') && n.className.indexOf('hidden') === -1;
        });
    }
    if (slides().length < 2) return;
    galleryInit = true;

    var badge = document.createElement('div');
    badge.className = 'cz-pd__count';
    badge.setAttribute('aria-hidden', 'true');
    var host = wrap.querySelector('.slider-mobile-gutter') || wrap;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    host.appendChild(badge);

    function render() {
      var s = slides();
      if (s.length < 2) { badge.style.display = 'none'; return; }
      badge.style.display = '';
      var i = 0;
      for (var k = 0; k < s.length; k++) {
        if (s[k].classList.contains('is-active')) { i = k; break; }
      }
      badge.textContent = (i + 1) + ' / ' + s.length;
    }
    render();

    if ('MutationObserver' in window) {
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t); t = setTimeout(render, 40);
      }).observe(list, { attributes: true, attributeFilter: ['class', 'hidden'], subtree: true, childList: true });
    }
    list.addEventListener('scroll', function () {
      clearTimeout(list.__czT);
      list.__czT = setTimeout(function () {
        var s = slides();
        if (list.scrollWidth <= list.clientWidth + 4) return render();
        var idx = Math.round(list.scrollLeft / (list.scrollWidth / s.length));
        if (idx < 0) idx = 0;
        if (idx > s.length - 1) idx = s.length - 1;
        badge.textContent = (idx + 1) + ' / ' + s.length;
      }, 70);
    }, { passive: true });
  }

  /* --- Yapiskan sepet seridi --- */
  function stickyBar() {
    var bar = document.querySelector('[data-cz-sticky]');
    if (!bar) return;
    var form = addForm();
    var anchor = document.querySelector('.product-form__buttons') || form;
    if (!form || !anchor) return;

    var btn = bar.querySelector('[data-cz-sticky-add]');
    var priceOut = bar.querySelector('[data-cz-sticky-price]');
    var livePrice = document.querySelector('.product__info-container .price');

    /* Dawn'in .price kutusunda gizli yedek spanlar da var;
       sadece gercekten gosterilen tutari oku */
    function readPrice() {
      if (!livePrice) return '';
      var onSale = livePrice.classList.contains('price--on-sale');
      var el = onSale
        ? livePrice.querySelector('.price__sale .price-item--sale')
        : livePrice.querySelector('.price__regular .price-item--regular');
      if (!el) el = livePrice.querySelector('.price-item');
      return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
    }
    function syncPrice() {
      if (!priceOut) return;
      var t = readPrice();
      if (t) priceOut.textContent = t;
    }
    syncPrice();
    if (livePrice && 'MutationObserver' in window) {
      new MutationObserver(syncPrice).observe(livePrice, { childList: true, subtree: true, characterData: true, attributes: true });
    }

    if (btn) {
      btn.addEventListener('click', function () {
        var f = addForm();
        var s = addButton(f);
        if (s && !s.disabled) { s.click(); return; }
        anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      var submit = addButton(form);
      if (submit && 'MutationObserver' in window) {
        var syncState = function () { btn.disabled = submit.disabled; };
        syncState();
        new MutationObserver(syncState).observe(submit, { attributes: true, attributeFilter: ['disabled'] });
      }
    }

    /* Her kaydirmada gercek konumu oku — IntersectionObserver'in
       dondurdugu eski dikdortgen yaniltiyordu.
       Masaustu: buton yukari kaybolunca serit gelir.
       Telefon: alis butonu iki ekran asagida (galeri + 8 beden + 4 cerceve);
       ilk ekrani gectikten sonra buton gorunmuyorsa — ustte ya da altta —
       serit gelir. Secili beden ve fiyat seritte yaziyor. */
    var ticking = false;
    function update() {
      ticking = false;
      var r = anchor.getBoundingClientRect();
      var mobile = window.innerWidth < 750;
      var below = r.top > window.innerHeight && window.scrollY > window.innerHeight * 0.55;
      bar.classList.toggle('is-on', r.bottom < 0 || (mobile && below));
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  /* --- Olcu rehberi --- */
  function currentSize() {
    var field = null;
    document.querySelectorAll('.product-form__input--pill').forEach(function (f) {
      if (/size|beden|boyut/.test(legendText(f))) field = f;
    });
    if (!field) return null;
    var checked = field.querySelector('input[type="radio"]:checked');
    if (!checked) return null;
    var label = field.querySelector('label[for="' + checked.id + '"]');
    /* Etiket metni yeniden bicimlendirildigi icin ham deger onceliklidir */
    var raw = label ? label.getAttribute('data-cz-raw') : null;
    var tn = label ? firstTextNode(label) : null;
    var txt = raw || (tn ? tn.textContent.trim() : checked.value);
    var d = parseInches(txt);
    return d ? { w: d.w, h: d.h, label: txt } : null;
  }

  /* Ayni cizim iki yerde: alis kutusunun icinde (satir ici) ve olcu rehberi
     cekmecesinde. Ikisi de ayni data-cz-sg-svg isaretini tasiyor, bu yuzden
     hepsi birden guncelleniyor. */
  function drawScale() {
    var size = currentSize();
    if (!size) return;
    document.querySelectorAll('[data-cz-sg-svg]').forEach(function (svg) {
      drawOne(svg, size);
    });
    markTable(size);
  }

  /* Cizimdeki olcu yazisi inctir: alicilarin cogu ABD'de ve orada olcu inc.
     Santim karsiligi hemen altindaki tabloda duruyor, o yuzden buraya
     koymuyoruz: iki birim yan yana yazilinca kucuk bedenlerde yatay ve
     dikey etiketler ust uste biniyordu. Ornek: 16″. */
  function incEtiketi(inc) {
    var i = Math.round(inc * 2) / 2;
    return ((i % 1 === 0) ? i.toFixed(0) : i.toFixed(1)) + '″';
  }

  function drawOne(svg, size) {
    var art = svg.querySelector('[data-cz-art]');
    var lblW = svg.querySelector('[data-cz-art-w]');
    var lblH = svg.querySelector('[data-cz-art-h]');
    if (!art) return;

    var wCm = size.w * 2.54, hCm = size.h * 2.54;
    var cx = 96, centreFromFloor = 148;
    var x = cx - wCm / 2;
    var y = 200 - (centreFromFloor + hCm / 2);

    art.setAttribute('x', x.toFixed(1));
    art.setAttribute('y', y.toFixed(1));
    art.setAttribute('width', wCm.toFixed(1));
    art.setAttribute('height', hCm.toFixed(1));

    if (lblW) {
      lblW.setAttribute('x', cx.toFixed(1));
      lblW.setAttribute('y', (y - 5).toFixed(1));
      lblW.textContent = incEtiketi(size.w);
    }
    if (lblH) {
      var hx = (x - 5).toFixed(1), hy = (y + hCm / 2).toFixed(1);
      lblH.setAttribute('x', hx);
      lblH.setAttribute('y', hy);
      lblH.setAttribute('transform', 'rotate(-90 ' + hx + ' ' + hy + ')');
      lblH.textContent = incEtiketi(size.h);
    }
  }

  function markTable(size) {
    var tbl = document.querySelector('[data-cz-sg-table]');
    if (!tbl) return;
    tbl.querySelectorAll('tr[data-size]').forEach(function (tr) {
      tr.classList.toggle('is-on', tr.getAttribute('data-size') === size.label);
    });
  }

  function sizeGuide() {
    var drawer = document.getElementById('CzSizeGuide');
    if (!drawer) return;
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      drawScale();
      var c = drawer.querySelector('.cz-sg__close');
      if (c) c.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cz-sg-open]')) { e.preventDefault(); open(); }
      else if (e.target.closest('[data-cz-sg-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  function enhance() {
    decorateOptions();
    deliveryEstimate();
    drawScale();
  }

  function init() {
    enhance();
    galleryCounter();
    stickyBar();
    sizeGuide();

    var info = document.querySelector('.product__info-container');
    if (info && 'MutationObserver' in window) {
      var t = null;
      /* Varyant degisince tema secenek blogunu sunucudan gelen HAM haliyle
         degistiriyor (9" x 12" (Vertical), fiyatsiz, noktasiz). Susleme
         eskiden 60 ms'lik, her degisiklikte yeniden baslayan bir zamanlayiciya
         bagliydi; tema ayni anda fiyati ve galeriyi de degistirdigi icin
         susleme ~300 ms gecikiyor ve ham hali ekranda titreme olarak
         goruluyordu. Artik secenekleri gozlemcinin ICINDE, tarayici boyamadan
         once sulluyoruz (islem idempotent: data-cz-done). Agir isler
         (teslimat, cizim) eskisi gibi ertelenir. */
      new MutationObserver(function () {
        decorateOptions();
        clearTimeout(t);
        t = setTimeout(enhance, 60);
      }).observe(info, { childList: true, subtree: true });
    }
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('.product-form__input')) {
        setTimeout(drawScale, 80);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();

/* ===== Olcu rehberi tablosu: yazimi pillerle ayni bicime getir =====
   data-size ozniteligine dokunmaz; sadece gorunen metni duzeltir. */
(function () {
  'use strict';
  var RE = /(\d+(?:\.\d+)?)\s*["″”]?\s*[x×]\s*(\d+(?:\.\d+)?)/i;

  function tidy() {
    document.querySelectorAll('[data-cz-sg-table] tr[data-size]').forEach(function (tr) {
      var pick = tr.querySelector('.cz-sg__pick');
      if (!pick || pick.hasAttribute('data-cz-fmt')) return;
      var m = RE.exec(tr.getAttribute('data-size') || '');
      if (!m) return;
      pick.textContent = m[1] + '″ × ' + m[2] + '″';
      pick.setAttribute('data-cz-fmt', '');
    });
  }

  function start() {
    tidy();
    var t = document.querySelector('[data-cz-sg-table]');
    if (t && 'MutationObserver' in window) {
      new MutationObserver(tidy).observe(t, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }
})();

/* ===== Aciklamadaki "Sizes" tablosu kaldirilir =====
   Yukaridaki beden secicinin birebir tekrariydi. Olcu bilgisi
   "Size guide" cekmecesinde duruyor; urun aciklamalarina dokunulmaz! */
(function () {
  'use strict';

  function strip() {
    var desc = document.querySelector('.product__description');
    if (!desc) return false;
    var h2s = desc.querySelectorAll('h2');
    for (var i = 0; i < h2s.length; i++) {
      if (!/^sizes?$/i.test(h2s[i].textContent.trim())) continue;
      var table = h2s[i].nextElementSibling;
      h2s[i].remove();
      if (table && table.tagName === 'TABLE') table.remove();
      return true;
    }
    return false;
  }

  function start() {
    if (strip()) return;
    var tries = 0;
    var id = setInterval(function () {
      if (strip() || ++tries > 20) clearInterval(id);
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }
})();
